export default __webpack_public_path__ + "static/media/architecture-img-27.70c81be1.jpg";